import React from 'react'
import clsx from 'clsx'
import Typography from '@mui/material/Typography'

import { ImgPure } from 'components/Img'

import styles from './TestimonialCard.module.scss'

type TestimonialCardProps = {
  avatar?: any
  name?: string
  message?: string
  title?: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = props => {
  const { avatar, name, message, title } = props
  return (
    <div className="mx-auto max-w-sm px-6 text-center">
      <Typography variant="h6" component="div" className="mb-9">
        {title}
      </Typography>

      <div className="mx-auto mb-6 h-22 w-22" title={name}>
        <ImgPure
          className={clsx(
            'pointer-events-none h-full w-full select-none rounded-full',
            styles.TestimonialAvatar
          )}
          src={avatar}
          alt={name}
          title={name}
        />
      </div>

      <Typography variant="body2" component="div" className="mb-5">
        {message}
      </Typography>

      <div className="text-white-med-on-dark">
        <Typography variant="caption" component="div">
          — {name}
        </Typography>
      </div>
    </div>
  )
}

export default TestimonialCard
